import {Injectable} from '@angular/core';
import {Storage} from '@ionic/storage-angular';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    public _storage: Storage = new Storage();

    public isCreated = false;
    constructor(private storage: Storage) {
    }
    async init() {
        this._storage = await this.storage.create();
        this.isCreated = true;
        return this.isCreated;
    }
    public set(key: string, value: any) {
        this._storage.set(key, value);
    }
    public get(key: string) {
        return this._storage.get(key);
    }
    public remove(key: string) {
        this._storage.remove(key);
    }

    public keys(): Promise<string[]> {
        return this._storage.keys();
    }

    public clear() {
        this._storage.clear();
    }

    public setMultiple(params: any) {
        for (var key in params) {
            this._storage.set(key, params[key]);
        }
    }
}
